/**
 * Display-time only: rewrites links to the Turkish brand domain inside stored
 * HTML into same-site relative paths so readers stay on the current deployment.
 * Stored content is never modified.
 */
const OWN = /href=(["'])https?:\/\/(?:www\.)?akillisurdurulebilirlik\.com(\/[^"']*)?\1/gi;
export function localizeOwnSiteLinks(html: string): string {
  if (!html) return html;
  return html.replace(OWN, (_m, q: string, path?: string) => {
    let p = path || "/";
    if (p.length > 1) p = p.replace(/\/(?=[?#]|$)/, "");
    return `href=${q}${p}${q}`;
  });
}

/**
 * Display-time only: a migration bug turned some in-text article links into links
 * to old image files on the previous site's storage. Only exact, title-verified
 * matches (stage-3 link report) are rewritten to the matching article; every
 * other link is left untouched. Stored content is never modified.
 */
const LEGACY_IMAGE_LINKS: Record<string, string> = {
  "3efe263b2a7c187a.jpg": "iklim-felaketi-kriz-inkarinin-yeni-yuzu",
  "a9294d72926bc411.jpg": "teknoloji-becerilerimizi-koreltiyor-mu",
  "7e377b508224b8d8.jpg": "yapay-zeka-ayrimi-yeni-bir-buyuk-ayrisma-yaklasiyor",
  "d9d2f6b8156be08f.jpg": "veri-etigi-olmadan-surdurulebilirlik-bir-yalandir",
};
const LEGACY = /href=(["'])https:\/\/pbxeqhwvxkrlaawepzxk\.supabase\.co\/storage\/v1\/object\/public\/post-images\/migrated\/([0-9a-f]+\.jpg)\1/gi;
export function repairLegacyImageLinks(html: string): string {
  if (!html) return html;
  return html.replace(LEGACY, (m, q: string, file: string) => {
    const slug = LEGACY_IMAGE_LINKS[file.toLowerCase()];
    return slug ? `href=${q}/yazilar/${slug}${q}` : m;
  });
}
